export default "{{$ctrl.country_name}}";